import { client, handleClientMethod } from "../client";
import type { ReviewQueueItem, ReviewQueueListParams, ReviewQueueApiResponse } from "@onsemble/shared/types/internal";

export async function getReviewQueue(
  params?: ReviewQueueListParams
): Promise<ReviewQueueItem[]> {
  const response = await handleClientMethod<ReviewQueueApiResponse>(
    client.GET("/api/internal/products/review-queue", {
      params: {
        query: params || {},
      },
    })
  );
  return response.data;
}
